import React, { Component, Fragment } from 'react';
import {connect} from "react-redux";
import {GroundFloorDurableFunctionInstance} from "../../../../models/DurableFunctionInstance";
import DispatchProps from "../../../../utils/DispatchProps";
import {IRootState} from "../../../../store";
import {WorkloadInstanceQuery} from "../../../../models/WorkloadInstanceQuery";
import GroundFloorDurableFunctionInstanceList from "../../../GroundFloorDurableFunctionInstanceList";
import * as H from "history";
import WorkloadQueryControls from "./WorkloadQueryControls";
import ApiService from "../../../ApiService";
import {Link} from "react-router-dom";
import {CommandBarButton, IDropdownOption, MessageBarType} from "office-ui-fabric-react";
import PageTitle from "../../../PageTitle";
import WorkloadResultsCharts from "./WorkloadResultsCharts";
import { userAccessLevelIsAtLeast, UserAccessLevel } from '../../../../models/UserAccessRecord';
import {buildIndexedSchools, IndexedSchools} from "../../../../utils/IndexedSchools";
import WorkloadInstancesBoxTable from "../../../WorkloadInstancesBoxTable";
import moment from 'moment';
import { openFileDownload } from '../../../../utils/Utils';
import Actions from '../../../../redux/Actions';

interface WorkloadDashboardPageProps {
    apiService: ApiService
    history: H.History;
    queryString: string;
    usersCdbAccessLevel?: UserAccessLevel;
}

interface WorkloadDashboardPageState {
    workloadInstanceQuery?: WorkloadInstanceQuery;
    workloadInstances?: GroundFloorDurableFunctionInstance[];
    workloadInstancesLoading: boolean;

    workloadAndPlaylistOptions?: IDropdownOption[];

    showResultsCharts: boolean;
    indexedSchools: IndexedSchools;
}

class WorkloadDashboardPage extends Component<WorkloadDashboardPageProps & DispatchProps ,WorkloadDashboardPageState> {
    static displayName = WorkloadDashboardPage.name;

    constructor(props: WorkloadDashboardPageProps & DispatchProps) {
        super(props);

        this.state = {
            workloadInstanceQuery: WorkloadInstanceQuery.withDefaults(),
            workloadInstances: undefined,
            workloadInstancesLoading: true,
            showResultsCharts: false,
            workloadAndPlaylistOptions: undefined,
            indexedSchools: {tenantIdSchoolCode: {},tenantNameSchoolCode: {}}
        }
    }
    
    async componentDidUpdate(prevProps: Readonly<WorkloadDashboardPageProps & DispatchProps>, prevState: Readonly<WorkloadDashboardPageState>, snapshot?: any): Promise<void> {
        
        if(this.props.queryString !== prevProps.queryString)
        {
            this.updateQueryFromUrl();
        }
        
        if(this.state.workloadInstanceQuery !== prevState.workloadInstanceQuery)
        {
            if(this.state.workloadInstanceQuery)
            {
                this.setState({
                    workloadInstancesLoading: true
                });

                const workloadInstances = await this.props.apiService.getGroundFloorDurableFunctionInstances(this.state.workloadInstanceQuery);

                this.setState({
                    workloadInstances: workloadInstances,
                    workloadInstancesLoading: false
                });
            }
        }
    }

    async componentDidMount() {
        
        const allSchools = await this.props.apiService.getSchoolsAdmin(true,true,false,[],[],"");
        this.setState({
            indexedSchools: buildIndexedSchools(allSchools)
        });
        
        const workloadAndPlaylistOptions = await WorkloadQueryControls.fetchWorkloadAndPlaylistOptions(this.props.apiService);
        this.setState({
            workloadAndPlaylistOptions: workloadAndPlaylistOptions
        });
        
        this.updateQueryFromUrl();
    }
    
    private updateQueryFromUrl()
    {
        if(this.props.queryString)
        {
            this.setState({
                workloadInstanceQuery: WorkloadInstanceQuery.fromQueryString(this.props.queryString)
            });
        }
        else
        {
            this.setState({
                workloadInstanceQuery: WorkloadInstanceQuery.withDefaults()
            });
        }
    }
    
    private onQueryChanged = (query: WorkloadInstanceQuery): void => {
        
        const queryString = ApiService.buildQueryString(query);
        this.props.history.push({search: queryString});
        
        this.setState({
            workloadInstanceQuery: query
        });
    };
    
    private onResetQueryClicked = (): void => {

        this.props.history.push({ search: "" });

        this.setState({
            workloadInstanceQuery: WorkloadInstanceQuery.withDefaults()
        });
    };

       render() {
        
        const chartResultsButton = (
            <CommandBarButton
                iconProps={{ iconName: "DonutChart" }}
                text="Chart Results"
                onClick={() => { 
                    this.setState({
                        showResultsCharts: true
                    });
                }}
            />
        );
        
        const workloadAnalyticsButton = (
            <Link to={`/cdb-admin/workloads/analytics`}>
                <CommandBarButton
                    iconProps={{ iconName: "Chart" }}
                    text="All Workload Analytics"
                    onClick={() => { }}
                />
            </Link>
        );

        const bulkWorkloadToolButton = (
            <Link to={`/cdb-admin/workloads/bulk`}>
                <CommandBarButton
                    iconProps={{ iconName: "Running" }}
                    text="Run Bulk Workload"
                    onClick={() => { }}
                />
            </Link>
        );

        const DownloadButton = (
            <CommandBarButton
                text={"Download Summary Data"}
                iconProps={{ iconName: "DownloadDocument" }}
                onClick={async () => {
                    try {
                        if (this.state.workloadInstanceQuery) {
                            let result;

                            result = await this.props.apiService.getGroundFloorDurableFunctionInstancesDownload(this.state.workloadInstanceQuery);

                            await openFileDownload(result)

                            this.props.dispatch(Actions.showMessageBar(`Downloading summary data`, MessageBarType.success));
                        }
                    }
                    catch (e) {
                        console.log(e);
                        this.props.dispatch(Actions.showMessageBar(`Error downloading summary data. If this problem persists please contact support. ${e.message}`, MessageBarType.error));
                    }
                }} />
        );
        
        const headerExtra = (
            <Fragment>
                {chartResultsButton}
                {workloadAnalyticsButton}
                {userAccessLevelIsAtLeast("admin", this.props.usersCdbAccessLevel) ? bulkWorkloadToolButton : null}
                {DownloadButton}
            </Fragment>
        );
        
        return (
            <Fragment>
                <PageTitle title={"Workloads"} />
                {this.state.workloadInstanceQuery && this.state.workloadAndPlaylistOptions ? <WorkloadQueryControls workloadInstanceQuery={this.state.workloadInstanceQuery} workloadAndPlaylistOptions={this.state.workloadAndPlaylistOptions} indexedSchools={this.state.indexedSchools} onQueryChanged={this.onQueryChanged} onResetQueryClicked={this.onResetQueryClicked} schoolOptionDisabled={false} /> : null}
                {this.state.showResultsCharts ? <WorkloadResultsCharts instances={this.state.workloadInstances!} onCloseClicked={() => this.setState({showResultsCharts: false})}/> : null}
                {this.state.showResultsCharts ? <WorkloadInstancesBoxTable startDate={this.state.workloadInstanceQuery!.fromDate!.toString()} endDate={moment(this.state.workloadInstanceQuery!.toDate!).subtract(1,'day').toString()} instances={this.state.workloadInstances!}/> : null}
                <GroundFloorDurableFunctionInstanceList instances={this.state.workloadInstances || []} indexedSchools={this.state.indexedSchools} title="Workloads" enableRowLinks={true} headerExtra={headerExtra} isLoading={this.state.workloadInstancesLoading} virtualize={true} />
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {history: H.History}): WorkloadDashboardPageProps => {
        return {
            apiService: state.auth.apiService,
            queryString: ownProps.history.location.search,
            history: ownProps.history,
            usersCdbAccessLevel: state.auth.usersCdbAccessLevel,
        };
    }
)(WorkloadDashboardPage);